import { BadgeProps, Tag, Tooltip } from "antd";
import { ReactNode } from "react";
import type { StoryboardStatus } from "../types";
import {
  CheckOutlined,
  ExclamationCircleOutlined,
  SyncOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { t } from "i18n";
import { radius } from "@libertify/ui";

const STATUS_COLORS: Record<StoryboardStatus, BadgeProps["status"]> = {
  Pending: "default",
  Initial: "default",
  Approved: "success",
  Generating: "processing",
  Reviewing: "warning",
  WaitingUserInput: "warning",
  Error: "error",
};

const STATUS_ICONS: Record<StoryboardStatus, ReactNode> = {
  Pending: <></>,
  Initial: <></>,
  Generating: <SyncOutlined spin />,
  Approved: <CheckOutlined />,
  Reviewing: <ExclamationCircleOutlined />,
  WaitingUserInput: <UserOutlined />,
  Error: <ExclamationCircleOutlined />,
};
const STATUS_LABELS: Record<StoryboardStatus, string | null> = {
  Pending: "Pending",
  Initial: "Initial",
  Generating: "Generating",
  Approved: "Approved",
  Reviewing: "Reviewing",
  WaitingUserInput: "WaitingUserInput",
  Error: "Error",
};

export const StoryboardStatusTag = ({
  status,
  tooltip,
}: {
  status: StoryboardStatus;
  tooltip?: ReactNode;
}) => {
  const color = STATUS_COLORS[status];
  const label = STATUS_LABELS[status] ?? status;

  return (
    <Tooltip title={tooltip}>
      <Tag
        color={color}
        icon={STATUS_ICONS[status]}
        style={{ border: 0, borderRadius: radius.pill }}
      >
        {t(`media.components.MediaStatus.${label}`)}
      </Tag>
    </Tooltip>
  );
};
